import Svg, { Path } from "react-native-svg";
import type { SvgProps } from "react-native-svg";
import { memo } from "react";
const SvgIcBack = (props: SvgProps) => <Svg xmlns="http://www.w3.org/2000/svg" width={28} height={46} fill="none" viewBox="0 0 28 46" {...props}><Path fill="currentColor" fillRule="evenodd" d="M23.35 0 .502 23l22.846 23 4.154-4.182L8.81 23 27.503 4.182 23.349 0Z" clipRule="evenodd" /></Svg>;
const Memo = memo(SvgIcBack);
export default Memo;